export default __webpack_public_path__ + "static/media/table-hero.a6dedc22.svg";